<template>
    <teleport to="#modal">
        <Loading
            :visible="loading||listaProgetti.loading"
        >
        </Loading>
    </teleport>
    <div id="selectModal"></div>
    <div class="m-auto px-8">
        <div class="m-auto pt-3">
            <div class="py-10 flex justify-between">
                <Breadcrumbs :paths="paths"></Breadcrumbs>
                <div class="flex">
                    <NextButton variant="outline-secondary" @click="$router.back()"
                                class="w-48 hidden text-sm sm:block py-2 px-4">
                        &lt; Indietro
                    </NextButton>
                </div>
            </div>
            <div class="flex justify-between items-center">
                <h1 class="font-bold text-xl mb-3">Sottoprogetti</h1>

                <Switcher v-model="tab_show" :options="['Tutti', 'Chiusi', 'Aperti']"
                          class="whitespace-nowrap mr-3"></Switcher>
            </div>

            <div class="pb-8">
                <div class="flex justify-end pt-2">
                    <Paginator class="" :pagination="listaProgetti.paginate"></Paginator>
                </div>
                <div class="rotate-x-180 overflow-x-scroll">
                    <NextTable class="rotate-x-180 w-full border-separate border-spacing-3 py-4 table-fixed"
                               v-model:cols="progettiCols"
                               :rows="progetti" @order-update="listaProgetti.updateCols">
                        <template v-for="(c, j) in progetti" :key="j" v-slot:[`td_${j}_2`]>
                            <TableTooltip inner_class="relative">
                                <MultiselectOption v-for="(option, i) in c.accounts" :key="i" readonly="true">
                                    {{ option.name }}
                                </MultiselectOption>
                            </TableTooltip>
                        </template>
                        <template v-for="(c, j) in progetti" :key="j"
                                  v-slot:[`td_${j}_4`]="context">
                            {{ context.context.row.business_unit?.label }}
                        </template>
                        <template v-for="(c, j) in progetti" :key="j"
                                  v-slot:[`td_${j}_5`]="context">
                            {{ $filters.toDate(context.context.row.data_inizio) }}
                        </template>
                        <template v-for="(c, j) in progetti" :key="j"
                                  v-slot:[`td_${j}_6`]="context">
                            {{ $filters.toDate(context.context.row.data_fine) }}
                        </template>
                        <template v-for="(c, j) in progetti" :key="j"
                                  v-slot:[`td_${j}_7`]="context">
                            {{ $filters.toEuroCurrency(context.context.row.budget) }}
                        </template>
                        <template v-for="(c, j) in progetti" :key="j"
                                  v-slot:[`td_${j}_9`]="context">
                            <router-link :to="{name:'DettaglioProgetto', params:{id:context.context.row.progetto_id}}"
                                         class="block text-center inset-0 absolute flex items-center justify-center">
                                <i
                                    class="icon-chevron_destra"></i></router-link>
                        </template>
                    </NextTable>
                </div>
                <InfiniteLoading @infinite="listaProgetti.fetchNextPage"
                                 :identifier="listaProgetti.infiniteIdentifier" style="min-height: 1px">
                    <template #complete>
                        <div class="text-center pb-3">Non ci sono altri sottoprogetti.</div>
                    </template>
                </InfiniteLoading>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import {Options, setup, Vue} from 'vue-class-component';
import Loading from "@/components/Loading.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import NextButton from "@/components/NextButton.vue";
import businessUnitsManager from "../api/BusinessUnits";
import Field from "@/components/Field.vue";
import clientiManager from "../api/Clienti";
import Alert from "@/components/Alert.vue";
import Autocomplete from "@/setup/Autocomplete";
import terminiPagamentoManager from "../api/TerminiPagamento";
import DynamicCell from "@/components/DynamicCell.vue";
import ModalInput from "@/components/ModalInput.vue";
import Lista from "@/setup/ListaCerca";
import sottoProgettiManager from "../api/SottoProgetti";
import progettiManager from "../api/Progetti";
import TabellaContextMenu from "@/components/TabellaContextMenu.vue";
import InfiniteLoading from "v3-infinite-loading";
import ContextMenuOpener from "@/setup/ContextMenuOpener";
import Paginator from "@/components/Paginator.vue";
import NextTable from "@/components/NextTable.vue";
import Switcher from "@/components/Switcher.vue";
import TableTooltip from "@/components/TableTooltip.vue";
import MultiselectOption from "@/components/MultiselectOption.vue";


@Options({
    name: 'SottoprogettiCliente',
    components: {
        MultiselectOption, TableTooltip,
        Switcher,
        DynamicCell,
        Alert,
        Field,
        NextButton,
        Breadcrumbs,
        Loading,
        InfiniteLoading,
        TabellaContextMenu,
        Paginator,
        NextTable
    },
    props: {
        id: [String, Number]
    }
})
export default class SottoprogettiCliente extends Vue {
    cmOpener: any = setup(() => ContextMenuOpener())
    id!: string | number
    loading = false
    tab_show = 0

    listaProgetti: any = setup(() => Lista(clientiManager, this.progettiCols, clientiManager.sottoprogetti))

    get progetti() {
        console.log('progetti');
        if (this.tab_show === 1) {
            return this.listaProgetti.rows.filter(((row: any) => row.is_aperto === false));
        } else if (this.tab_show === 2) {
            return this.listaProgetti.rows.filter(((row: any) => row.is_aperto === true));
        }
        return this.listaProgetti.rows;
    }

    created() {
        this.listaProgetti.sort = '-data_inizio'
        this.listaProgetti.callBinds = [this.id]

        this.resetView();
    }

    resetView() {
        this.listaProgetti.debounceSearch()
    }

    mounted() {
        this.resetView()
    }

    get paths() {
        return [
            {
                title: 'Home',
                name: 'Dashboard',
            },
            {
                title: 'Anagrafica',
                name: 'DettaglioAzienda',
                params: {id: this.id}
            },
            {
                title: 'Sottoprogetti',
                name: 'SottoprogettiCliente',
            },
        ]
    }

    progettiCols: any[] = [
        // {
        //     name: 'ID',
        //     prop: 'id',
        //     orderable: true,
        //     class: 'text-left min-w-200 w-40 whitespace-nowrap',
        //     td_class: 'h-11.5 px-2 relative bg-next-gray-md-dark',
        //     resizable: false
        // },
        {
            name: 'Cod. nodo',
            prop: 'cod_nodo',
            orderable: true,
            class: 'text-left w-36 whitespace-nowrap',
            td_class: 'h-11.5 px-2 relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Titolo',
            prop: 'titolo',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'h-11.5 px-2 relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Accounts',
            prop: 'accounts',
            orderable: false,
            class: 'text-left whitespace-nowrap',
            td_class: 'h-11.5 pt-1 relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Anno',
            prop: 'anno',
            orderable: true,
            class: 'text-left w-20 whitespace-nowrap',
            td_class: 'h-11.5 px-2 relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'BU',
            prop: 'business_unit',
            orderable: true,
            ordProp: 'business_units.nome',
            class: 'text-left w-20 whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Data inizio',
            prop: 'data_inizio',
            order: 2,
            orderable: true,
            class: 'text-left min-w-110 w-28 whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Data fine',
            prop: 'data_fine',
            orderable: true,
            class: 'text-left min-w-110 w-28 whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Budget aper.',
            prop: 'budget',
            orderable: true,
            class: 'text-left min-w-110 w-32 whitespace-nowrap',
            td_class: 'text-right px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Stato',
            prop: 'stato_next_descrizione',
            orderable: true,
            ordProp: 'stato',
            class: 'text-left w-32 whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark text-right',
            resizable: false
        },
        {
            name: '',
            prop: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative hover:bg-next-orange hover:text-white bg-next-gray-md-dark',
            resizable: false
        },
        // {
        //     name: '',
        //     prop: '',
        //     orderable: false,
        //     class: 'min-w-10 w-10 whitespace-nowrap border-r-0',
        //     td_class: 'relative hover:bg-next-orange hover:text-white border-r-0 bg-next-gray-md-dark',
        //     resizable: false
        // }
    ]
}
</script>


<style lang="scss">

</style>
